<template>
  <div :class="[`brands__brand brands__brand--${slug}`, { 'brands__brand--filter-ready': filterReady }]" :style="`background-image: url(${assetPath}brand-assets/${backgroundImage})`">
    <!-- <div class="brands__logo" v-if="filterReady">
      <img :src="assetPath + 'brand-assets/' + filterLogo" alt="">
    </div>
    <div class="brands__logo" v-else>
      <img :src="assetPath + 'brand-assets/' + logo" alt="">
    </div> -->
    <div class="brands__logo">
      <img :src="assetPath + 'brand-assets/' + logo" alt="">
    </div>
    <p v-html="copy"></p>
    <button v-if="filterReady" class="brands__filter-link" type="button" @click="pickBrand(slug)" aria-controls="product-results">
      View <strong v-html="brand" /> Recommendations >
    </button>
    <a v-else :href="link" data-gtmcat="OCS Engagement" data-gtmaction="click" :data-gtmlabel="'Brand Engagement | ' + slug" class="button" v-html="linkText"></a>
  </div>
</template>

<script>
import zenscroll from 'zenscroll'

import { assetPath } from './../../mixins/assetPath.js'
import { pageMode } from './../../mixins/pageMode.js'

export default {
  name: 'Brand',
  props: {
    brand: {
      type: String,
      default: ''
    },
    logo: {
      type: String,
      default: ''
    },
    filterLogo: {
      type: String,
      default: ''
    },
    slug: {
      type: String,
      default: ''
    },
    copy: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    linkText: {
      type: String,
      default: `Learn More`
    },
    backgroundImage : {
      type: String,
      default: ''
    }
  },
  computed: {
    eMailSubmitted() {
      return this.$store.state.results.complete
    },
    filterReady () {
      return this.pageMode === 'managers' && this.eMailSubmitted
    }
  },
  methods: {
    pickBrand(brand) {
      // console.log(brand)
      // eslint-disable-next-line
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: 'OCS Engagement',
          eventAction: 'click',
          eventLabel: 'Brand Choice | ' + brand,
        });
      }
      this.$store.dispatch('pickBrand', brand)
      // this.$emit('brandSelected', brand)
      setTimeout(() => zenscroll.to(document.getElementById('products-wrapper')), 500)
    }
  },
  mixins: [assetPath, pageMode]
}
</script>

<style lang="scss">
  .brands__brand {
    flex: 1 1 auto;
    text-align: center;
    // height: 240px;
    background-color: $gray;
    background-size: cover;
    background-repeat: repeat-x;
    background-position: center bottom;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 1.5em 1em 2em 1em;
    p {
      color: white;
      width: 100%;
      flex: 1 1 auto;
      max-width: 32em;
      font-size: 1em;
    }
    @include breakpoint(large) {
      height: 360px;
    }
    // @include breakpoint(xlarge) {
    //   height: 340px;
    // }
  }

  .brands__logo {
    // max-width: 50%;
    height: 74px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
  }
  
  .brands__brand--folgers {
    background-size: cover;
    background-color: $red;
    .brands__logo {
      max-width: 183px;
    }
    .button {
      background-color: $orange;
      color: $black;
      &:hover {
        background-color: $orange-hover;
      }
    }
  }

  .brands__brand--1850 {
    .brands__logo {
      max-width: 170px;
    }
    /* &.brands__brand--filter-ready {
      .brands__logo {
        max-width: 90px;
      }
    } */
    .button {
      background-color: $gold;
      &:hover {
        background-color: $gold-hover;
      }
    }
  }

  .brands__brand--cafe-bustelo {
    .brands__logo {
      max-width: 127px;
    }
    p {
      color: $cafe-blue;
    }
    .button {
      background-color: $cafe-red;
      &:hover {
        background-color: $cafe-red-hover;
      }
    }
    .brands__filter-link {
      color: $cafe-blue;
    }
  }

  .brands__brand--select-brew {
    .brands__logo {
      max-width: 151px;
    }
    p {
      color: $select-brew-brown;
    }
    .button {
      background-color: $select-brew-blue;
      &:hover {
        background-color: $select-brew-blue-hover;
      }
    }
  }

  /* .brands__brand--filter-ready {
    background-image: none !important;
    background-color: white !important;
    height: auto !important;
    p {
      color: $lgrayer;
    }
  } */

  .brands__filter-link {
    padding: 0;
    background-color: transparent;
    /* color: $green; */
    color: white;
    font-family: $serif;
    text-decoration: underline;
    font-size: 14px;
    strong {
      font-weight: 900;
    }
    /* &:hover {
      color: $green-hover;
    } */
  }
</style>